import { DropDownItem } from "../../../pojo/DropDownItem";

export function dropdownItemFromId(id: number | null | undefined): DropDownItem | undefined {
    if (id == null || !Number.isFinite(id)) {
        return undefined;
    }
    return { itemId: id, val: id };
}

export function idFromDropdownItem(choice: DropDownItem | null | undefined): number | undefined {
    if (!choice || choice.isNoneItem) {
        return undefined;
    }
    const raw = choice.itemId ?? choice.val;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : undefined;
}

export function dropdownItemsFromIds(ids: number[] | undefined): DropDownItem[] {
    if (!ids?.length) {
        return [];
    }
    return ids.map((id) => dropdownItemFromId(id)).filter((item): item is DropDownItem => item != null);
}

export function idsFromDropdownItems(items: DropDownItem[] | null | undefined): number[] {
    if (!items?.length) {
        return [];
    }
    return items.map((item) => idFromDropdownItem(item)).filter((id): id is number => id != null);
}
